// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DrawerUserInfo_wrapper__qkB0V","avatar":"DrawerUserInfo_avatar__DHKJF","name":"DrawerUserInfo_name__cTXIj","status":"DrawerUserInfo_status__V9k3D"};